import { get } from 'lodash';
import { validateLanguage } from './validate-language';

export const getCurrentSiteLanguage = (wixCodeApi) => {
  const multilingualLanguage = get(wixCodeApi, 'window.multilingual.currentLanguage');
  return validateLanguage(multilingualLanguage || wixCodeApi.site.language);
};
